(function(w,d){
  'use strict';
  if (w.__ES_PDP_PRIORITY_BOOT__) return;
  w.__ES_PDP_PRIORITY_BOOT__ = true;

  var assets = w.__ES_PDP_LAZY_ASSETS || {};
  var ES = w.ES || null;
  var loaded = Object.create(null);
  var promises = Object.create(null);
  var launchGeneration = 0;
  var pendingLaunchCleanups = [];
  w.addEventListener('pagehide', function(){
    launchGeneration += 1;
    pendingLaunchCleanups.forEach(function(cleanup){ cleanup(); });
  });

  function report(scope, error){
    try {
      if (typeof w.ESDebug === 'function') w.ESDebug(scope, error);
      else if (w.Shopify && w.Shopify.designMode && w.console && console.warn) console.warn('[EYESHELLS][' + scope + ']', error);
    } catch(_debugError) {}
  }

  function scheduleIdle(callback, timeout){
    if (ES && ES.scheduler && typeof ES.scheduler.idle === 'function') {
      return ES.scheduler.idle(callback, timeout);
    }
    var active = true;
    var id;
    var run = function(){ if (!active) return; active = false; callback(); };
    if (w.requestIdleCallback) id = w.requestIdleCallback(run, { timeout: timeout || 700 });
    else id = w.setTimeout(run, Math.max(0, timeout == null ? 700 : timeout));
    return function(){
      if (!active) return;
      active = false;
      try {
        if (w.cancelIdleCallback && w.requestIdleCallback) w.cancelIdleCallback(id);
        else w.clearTimeout(id);
      } catch(e) {}
    };
  }

  function observeNear(element, callback, options){
    if (ES && ES.observe && typeof ES.observe.intersection === 'function') {
      return ES.observe.intersection(element, function(entry){
        if (entry && entry.isIntersecting) callback();
      }, options || {});
    }
    if (!('IntersectionObserver' in w)) return null;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        try { io.disconnect(); } catch(e) {}
        callback();
      });
    }, options || {});
    io.observe(element);
    return function(){ try { io.disconnect(); } catch(e) {} };
  }

  function once(key, factory){
    if (loaded[key]) return Promise.resolve();
    if (promises[key]) return promises[key];

    try {
      promises[key] = Promise.resolve(factory()).then(function(){
        loaded[key] = true;
        delete promises[key];
      }).catch(function(error){
        delete promises[key];
        throw error;
      });
    } catch (error) {
      return Promise.reject(error);
    }
    return promises[key];
  }

  function absoluteUrl(url){
    try { return new URL(url, d.baseURI).href; } catch(e) { return String(url || ''); }
  }

  function findAssetNode(selector, attribute, url){
    var wanted = absoluteUrl(url);
    var nodes = d.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      try {
        if (absoluteUrl(node.getAttribute(attribute) || node[attribute]) === wanted) return node;
      } catch(e) {}
    }
    return null;
  }

  function loadScript(url){
    if (!url) return Promise.resolve();
    var found = findAssetNode('script[src]', 'src', url);
    if (found && found.dataset.esLoadFailed === '1') { found.remove(); found = null; }
    var created = !found;
    var script = found || d.createElement('script');
    if (script.dataset.esLoaded === '1' || script.readyState === 'complete') return Promise.resolve();
    if (script.__esPriorityPromise) return script.__esPriorityPromise;
    if (created) { script.src = url; script.async = false; script.dataset.esDynamic = '1'; }
    var promise = new Promise(function(resolve, reject){
      var timer;
      var settled = false;
      function finish(error){
        if (settled) return;
        settled = true;
        w.clearTimeout(timer);
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
        if (error) {
          script.dataset.esLoadFailed = '1';
          try { script.remove(); } catch(_removeScriptError) {}
          reject(error);
        } else {
          script.dataset.esLoaded = '1';
          resolve();
        }
      }
      function onLoad(){ finish(); }
      function onError(){ finish(new Error('Failed to load script: ' + url)); }
      script.addEventListener('load', onLoad);
      script.addEventListener('error', onError);
      timer = w.setTimeout(function(){
        finish(script.dataset.esLoaded === '1' ? null : new Error('Script loading timed out: ' + url));
      }, 15000);
      if (created) {
        try { (d.body || d.head || d.documentElement).appendChild(script); }
        catch (error) { finish(error); }
      }
    });
    script.__esPriorityPromise = promise;
    promise.then(function(){ script.__esPriorityPromise = null; }, function(){ script.__esPriorityPromise = null; });
    return promise;
  }

  function ensureStyle(url){
    if (!url) return Promise.resolve();
    return new Promise(function(resolve, reject){
      var found = findAssetNode('link[href]', 'href', url);
      if (found && found.dataset.esLoadFailed === '1') {
        try { found.remove(); } catch(e) {}
        found = null;
      }

      function ready(node){
        if (!node) return false;
        try { return !!node.sheet || node.dataset.esLoaded === '1'; }
        catch(e) { return node.dataset.esLoaded === '1'; }
      }

      function bind(node){
        if (ready(node)) { resolve(); return; }
        var settled = false;
        var timer;
        function finish(error){
          if (settled) return;
          settled = true;
          w.clearTimeout(timer);
          node.removeEventListener('load', onLoad);
          node.removeEventListener('error', onError);
          if (error) {
            node.dataset.esLoadFailed = '1';
            try { node.remove(); } catch(_removeStyleError) {}
            reject(error);
          } else {
            node.dataset.esLoaded = '1';
            resolve();
          }
        }
        function onLoad(){ finish(); }
        function onError(){ finish(new Error('Failed to load stylesheet: ' + url)); }
        node.addEventListener('load', onLoad, { once:true });
        node.addEventListener('error', onError, { once:true });
        timer = w.setTimeout(function(){
          finish(ready(node) ? null : new Error('Stylesheet timed out: ' + url));
        }, 8000);
      }

      if (found) {
        var rel = String(found.getAttribute('rel') || '').toLowerCase();
        if (rel.indexOf('stylesheet') === -1) {
          try {
            found.onload = null;
            found.removeAttribute('onload');
            found.removeAttribute('as');
            found.setAttribute('rel', 'stylesheet');
            found.dataset.esStylePromoted = '1';
          } catch(e) {}
        }
        bind(found);
        return;
      }

      var link = d.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.esDynamic = '1';
      bind(link);
      var contract = d.querySelector('link[data-es-pdp-contract]');
      try {
        if (contract && contract.parentNode) contract.parentNode.insertBefore(link, contract);
        else d.head.appendChild(link);
      } catch (error) {
        link.dispatchEvent(new Event('error'));
      }
    });
  }

  function whenReady(fn){
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  function quickviewAllowed(){
    try {
      if (typeof w.ES_quickViewAllowed === 'function') return w.ES_quickViewAllowed();
      if (w.matchMedia) return w.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches;
    } catch(e) {}
    return false;
  }

  function fallbackToHref(trigger){
    try {
      var href = trigger && trigger.getAttribute ? trigger.getAttribute('href') : '';
      if (href && href !== '#' && !/^javascript:/i.test(href)) w.location.href = href;
    } catch(e) {}
  }

  function ensureRelatedModule(){
    return once('relatedModule', function(){
      return ensureStyle(assets.relatedCss).then(function(){
        return loadScript(assets.relatedJs);
      }).then(function(){
        try {
          if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
            w.ES_jqReady(function($){
              try { $(d).trigger('shopify:section:load'); } catch(e) {}
            });
          }
        } catch(e) {}
      });
    });
  }

  function ensureQuickviewBundle(){
    if (!quickviewAllowed()) return Promise.resolve();
    return once('quickviewBundle', function(){
      return Promise.all([ensureRelatedModule(), ensureStyle(assets.quickviewCss)])
        // Product pages use a separate lazy-loading path from collection/home.
        // Load the Quick View component stylesheet before its runtime so the
        // first related-product popup never opens with legacy fallback layout.
        // Quick View owns only its own runtime. Lens Builder is loaded later,
        // on Select Lenses intent, by es-quickview-select-lenses.js.
        .then(function(){ return loadScript(assets.quickviewJs); })
        .then(function(){ return loadScript(assets.quickviewLensJs); })
        .then(function(){
          try {
            if (quickviewAllowed() && w.jQuery && typeof w.quickView === 'function') w.quickView();
            if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
              w.ES_jqReady(function($){
                try { if (quickviewAllowed() && w.quickView) w.quickView(); } catch(e) {}
                try { $(d).trigger('shopify:section:load'); } catch(e2) {}
              });
            }
          } catch(e) {}
        });
    });
  }

  function ensureLensbuilder(){
    if (!assets.hasLensbuilder || !assets.lensbuilderJs) return Promise.resolve();
    if (w.__esLensBuilderBooted) { loaded.lensbuilder = true; return Promise.resolve(); }
    return once('lensbuilder', function(){
      // 1757: fetch JS while CSS is loading, but retain the CSS-ready gate
      // before executing the builder. Preload does not initialize the modal.
      if (!findAssetNode('link[rel="preload"][as="script"]', 'href', assets.lensbuilderJs) &&
          !findAssetNode('script[src]', 'src', assets.lensbuilderJs)) {
        var preload = d.createElement('link');
        preload.rel = 'preload';
        preload.as = 'script';
        preload.href = assets.lensbuilderJs;
        (d.head || d.documentElement).appendChild(preload);
      }
      return ensureStyle(assets.lensbuilderCss)
        .then(function(){ return loadScript(assets.lensbuilderJs); });
    });
  }

  function ensureFancybox(){
    return once('fancybox', function(){
      return loadScript(assets.fancyboxUmd)
        .then(function(){ return loadScript(assets.fancyboxBinder); });
    });
  }

  function observeRelated(){
    // Keep PDP lighter by loading related-products runtime only when the section is near view
    // or when the customer shows intent; avoid idle-loading it for every PDP visitor.
    var root = d.querySelector('[data-es-related-root]');
    if (!root) return;
    var kicked = false;
    var kick = function(){
      if (kicked) return;
      kicked = true;
      ensureRelatedModule().catch(function(error){ kicked = false; report('pdp-related-load', error); });
    };

    var stopNear = observeNear(root, function(){
      if (stopNear) { try { stopNear(); } catch(e) {} stopNear = null; }
      kick();
    }, { rootMargin: '1400px 0px' });
    if (!stopNear) scheduleIdle(kick, 1400);

    d.addEventListener('pointerenter', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    }, true);

    d.addEventListener('focusin', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    });

    var pendingButton = null;
    var replayPending = false;
    pendingLaunchCleanups.push(function(){ pendingButton = null; replayPending = false; });
    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-related-root] .engoj_btn_quickview') : null;
      if (!btn || !quickviewAllowed() || loaded.quickviewBundle) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      pendingButton = btn;
      if (replayPending) return;
      replayPending = true;
      var generation = launchGeneration;
      ensureQuickviewBundle().then(function(){
        if (generation !== launchGeneration) return;
        var replay = pendingButton;
        pendingButton = null;
        replayPending = false;
        w.setTimeout(function(){
          if (generation === launchGeneration && replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(error){
        if (generation !== launchGeneration) return;
        var fallback = pendingButton;
        pendingButton = null;
        replayPending = false;
        report('pdp-related-quickview', error);
        fallbackToHref(fallback);
      });
    }, true);
  }

  function prepareLensbuilderLaunch(){
    if (!assets.hasLensbuilder) return;
    function feedback(button,message){
      if(!button)return;
      var note=button.__esLensLoadNote;
      if(!note&&message){note=d.createElement('span');note.className='es-lensbuilder-launch-feedback';note.setAttribute('role','status');note.setAttribute('aria-live','polite');note.style.cssText='display:block;flex-basis:100%;max-width:100%;font-size:12px;line-height:1.5;margin-top:6px;';button.insertAdjacentElement('afterend',note);button.__esLensLoadNote=note;}
      if(note){note.textContent=message||'';note.hidden=!message;}
    }
    function allowIdleWarmup(){
      var connection=w.navigator&&(w.navigator.connection||w.navigator.mozConnection||w.navigator.webkitConnection);
      return !connection||(!connection.saveData&&!/^(?:slow-2g|2g|3g)$/.test(String(connection.effectiveType||'')));
    }
    function warm(){ ensureLensbuilder().catch(function(error){ report('pdp-lensbuilder-warm', error); }); }

    try {
      var resumeParams = new URL(w.location.href).searchParams;
      if (resumeParams.get('openLensBuilder') === '1' || resumeParams.get('openLensBuilder') === 'true') warm();
    } catch(e) {}

    d.addEventListener('pointerenter', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    });

    d.addEventListener('touchstart', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, { passive:true, capture:true });

    var pendingButton = null;
    var replayPending = false;
    pendingLaunchCleanups.push(function(){
      if (pendingButton) {pendingButton.removeAttribute('aria-busy');feedback(pendingButton,'');}
      pendingButton = null; replayPending = false;
    });
    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (!btn || loaded.lensbuilder || w.__esLensBuilderBooted) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();

      if (pendingButton && pendingButton !== btn) {pendingButton.removeAttribute('aria-busy');feedback(pendingButton,'');}
      pendingButton = btn;
      btn.setAttribute('aria-busy', 'true');
      feedback(btn,'Opening lens options...');
      if (replayPending) return;
      replayPending = true;
      var generation = launchGeneration;

      ensureLensbuilder().then(function(){
        if (generation !== launchGeneration) return;
        var replay = pendingButton;
        pendingButton = null;
        replayPending = false;
        if (replay) {replay.removeAttribute('aria-busy');feedback(replay,'');}
        w.setTimeout(function(){
          if (generation === launchGeneration && replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(error){
        if (generation !== launchGeneration) return;
        var failed = pendingButton;
        pendingButton = null;
        replayPending = false;
        if (failed) {failed.removeAttribute('aria-busy');feedback(failed,'Lens options could not open. Please tap Select Lenses again.');}
        report('pdp-lensbuilder-open', error);
      });
    }, true);

    if(allowIdleWarmup())scheduleIdle(function(){if(d.visibilityState!=='hidden'&&allowIdleWarmup())warm();},3200);
  }

  function prepareFancybox(){
    function warm(){ ensureFancybox().catch(function(){}); }

    d.addEventListener('pointerenter', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    });

    // Mobile: preload the Fancybox runtime on touchstart, before the click event.
    d.addEventListener('touchstart', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, { passive:true, capture:true });

    var pendingTrigger = null;
    var replayPending = false;
    pendingLaunchCleanups.push(function(){ pendingTrigger = null; replayPending = false; });
    d.addEventListener('click', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (!trigger || loaded.fancybox) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      pendingTrigger = trigger;
      if (replayPending) return;
      replayPending = true;
      var generation = launchGeneration;
      ensureFancybox().then(function(){
        if (generation !== launchGeneration) return;
        var replay = pendingTrigger;
        pendingTrigger = null;
        replayPending = false;
        w.setTimeout(function(){
          if (generation === launchGeneration && replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(){
        if (generation !== launchGeneration) return;
        var fallback = pendingTrigger;
        pendingTrigger = null;
        replayPending = false;
        fallbackToHref(fallback);
      });
    }, true);

    scheduleIdle(warm, 2600);
  }

  whenReady(function(){
    observeRelated();
    prepareLensbuilderLaunch();
    prepareFancybox();
  });
})(window, document);
